(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cbd-lab-tests"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function() {
  $('.tab-button').on('click', function() {
    // Remove active class from all buttons and contents
    $('.tab-button').removeClass('active');
    $('.tab-content').removeClass('active');
    
    // Add active class to clicked button
    $(this).addClass('active');
    
    // Show corresponding content
    const tabId = $(this).data('tab');
    $('#' + tabId).addClass('active');
  });
  
  // Activate first tab by default if none is active
  if ($('.tab-button.active').length === 0 && $('.tab-button').length > 0) {
    $('.tab-button:first').trigger('click');
  }
});

  } catch(e) { console.error(e); }
})();
})();
